import { render } from "./OuterFileInputPage.vue?vue&type=template&id=8b433c60&scoped=true&ts=true"
import script from "./OuterFileInputPage.vue?vue&type=script&lang=ts"
export * from "./OuterFileInputPage.vue?vue&type=script&lang=ts"

import "./OuterFileInputPage.vue?vue&type=style&index=0&id=8b433c60&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b433c60"]])

export default __exports__